import { Dialog, DialogProps } from "@mui/material";

import AppModalContent from "@/common/components/Modals/AppModalContent";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";
import { ViewVariant } from "@/common/ts/layout";

import VehicleDamageView, { VehicleDamageViewProps } from "./VehicleDamageView";

export interface OwnProps {
  viewProps: VehicleDamageViewProps;
}
type Props = OwnProps & DialogProps;

export default function VehicleDamageViewModal({ viewProps, ...modalProps }: Props) {
  const openStatus = useModalOpenStatus(modalProps);

  return (
    <Dialog fullWidth maxWidth='lg' {...modalProps}>
      <AppModalContent>
        {openStatus.isOpen && (
          <VehicleDamageView
            headerProps={{
              withLink: true,
              typographyProps: {
                variant: "h1",
              },
            }}
            {...viewProps}
            displayProps={{
              viewVariant: ViewVariant.Modal,
              closeInHeader: true,
              ...viewProps?.displayProps,
            }}
            onDelete={() => {
              modalProps.onClose && modalProps.onClose({}, "escapeKeyDown");
            }}
            onClose={() => {
              modalProps.onClose && modalProps.onClose({}, "backdropClick");
              viewProps.onClose && viewProps.onClose();
            }}
          />
        )}
      </AppModalContent>
    </Dialog>
  );
}
